module.exports = __webpack_public_path__ + "static/practice-06-cover-c02eaf877fa70b3bd7efe194f7dec909.jpg";